import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { sendUserMetadata } from "./api";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    sendUserMetadata();
  }, [pathname]);

  return null;
};
